// Development-only visual harness; requests stay local and never impersonate a customer.
import React, { useRef, useState } from "react";
import { Text, View, Pressable } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { t } from "@/localization";
import { SupportWidgetContent } from "./SupportWidget";
import { openSupport } from "./config";
// The page around the widget is translated; the synthetic chat stands in for
// server replies, which stay as they come.
export default function SupportDemo() {
  const root = useRef(null),
    nav = useRef({ getCurrentRoute: () => ({ name: "EventList" }) });
  const [delivery, setDelivery] = useState(t("No message sent"));
  // Synthetic earlier Intercom chat, to preview how imported Fin history renders.
  const previous = [
    {
      id: "demo-intercom",
      source: "intercom",
      title: "Replay length",
      updatedAt: "2026-09-12 10:00:00",
      messages: [
        { role: "user", body: "How long will the replay stay online?" },
        {
          role: "fin",
          body: "Replays stay online for one year.",
          author: "Fin",
        },
        {
          role: "staff",
          body: "Hi! Your event is on the 1-month plan. You can extend it from the event page.",
          author: "Julia Eskin",
        },
      ],
    },
  ];
  const request = async (body, session, options) => {
    if (options?.history) return { messages: [], state: "ai", previous };
    if (options?.previous) return { previous };
    if (body.initialize)
      return { id: "visual-demo", token: "not-a-real-token" };
    setDelivery(
      body.screenshot
        ? t("Demo delivery: screenshot included · {platform}", {
            platform: body.screen.platform,
          })
        : t("Demo delivery: no screenshot · {platform}", {
            platform: body.screen.platform,
          })
    );
    await new Promise((resolve) => setTimeout(resolve, 600));
    return {
      reply:
        "Open your event, choose Download & Stats, then select Download Video. I can help if you don’t see that option.",
      escalate: false,
      sources: [
        {
          id: "help",
          title: "Download your recording",
          url: "https://help.eventlive.pro/en/articles/11591041-how-to-access-and-download-livestream-recording-after-the-event",
        },
      ],
    };
  };
  return (
    <SafeAreaProvider>
      <View style={{ flex: 1 }}>
        <View
          ref={root}
          collapsable={false}
          style={{ flex: 1, backgroundColor: "#f4f6f5", padding: 32 }}
        >
          <Text style={{ fontSize: 24, fontWeight: "700", color: "#365b55" }}>
            {t("EventLive · Widget test")}
          </Text>
          <Text style={{ marginTop: 14 }}>
            {t(
              "Synthetic account and replies. No customer data or live API calls."
            )}
          </Text>
          <Text style={{ marginTop: 22, fontSize: 20 }}>
            {t("Your events")}
          </Text>
          <View
            style={{
              backgroundColor: "white",
              borderRadius: 16,
              padding: 20,
              marginTop: 20,
            }}
          >
            <Text>{t("Family celebration")}</Text>
            <Text>{t("Published · Recording ready")}</Text>
          </View>
          <Text
            accessibilityLabel={t("Demo delivery status")}
            style={{ marginTop: 20 }}
          >
            {delivery}
          </Text>
          <Pressable onPress={openSupport}>
            <Text style={{ marginTop: 20, color: "#365b55" }}>
              {t("Open support")}
            </Text>
          </Pressable>
        </View>
        <SupportWidgetContent
          screenRef={root}
          navigationRef={nav}
          auth={{
            broadcaster: "visual-test-account",
            isSignedOut: false,
            isLoading: false,
          }}
          request={request}
        />
      </View>
    </SafeAreaProvider>
  );
}
